<template>
<div class="spinner !m-0" :style="{width: size, height: size, borderWidth: lineWidth}" :class="[PROPS.color]"></div>
</template>

<script lang="ts" setup>

const PROPS = defineProps({
  color: {
    type: String,
    default: 'black',
    required: false
  },
  size: {
    type: String,
    default: '50px'
  },
  lineWidth: {
    type: String,
    default: '3px'
  }
})
</script>

<style lang="scss">
.spinner {
  place-self: center;
  border-radius: 50%;
  border: 3px solid black;
  border-top-color: transparent;
  animation: spin 1s infinite linear, fadeIn 0.5s;
  // animation-delay: 0.1s;

  &.black {
    border: 3px solid black;
    border-top-color: transparent;
  }

  &.white {
    border: 3px solid white;
    border-top-color: transparent;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
